import { Tab, Tabs, Typography } from '@mui/material';
import { pull } from 'lodash';

import Header from '@client/components/Header';
import { getRole } from '@client/new/components/AdminMenu/helpers';
import { useInfluencerId } from '@client/new/contexts/InfluencerIdContext';
import { keys } from '@client/new/helpers/general';
import { useTabHash } from '@client/new/hooks/useTabHash';

import { PayoutRules } from '../settings/payoutRules/PayoutRules';
import { Dashboard } from './dashboard';
import { PaymentMethod } from './paymentMethod';

const tabs = {
  paymentMethod: 'Payment method',
  dashboard: 'Dashboard',
  rules: 'Rules',
} as const;

type PayoutTab = keyof typeof tabs;

export const PayoutsPage = () => {
  const influencerId = useInfluencerId();
  const role = getRole();

  const tabsByRole =
    role === 'admin'
      ? pull(keys(tabs), 'paymentMethod')
      : pull(keys(tabs), 'rules');

  const { tabHash, onTabChange } = useTabHash<PayoutTab>(
    tabsByRole,
    tabsByRole[0],
  );

  const renderTab = (tab: PayoutTab) => {
    switch (tab) {
      case 'rules':
        return <PayoutRules influencerId={influencerId} />;
      case 'dashboard':
        return <Dashboard creatorId={influencerId} />;
      case 'paymentMethod':
        return <PaymentMethod />;
    }
  };

  return (
    <div>
      <Header>
        <Typography variant="h1" sx={{ fontSize: 30, fontWeight: 700 }}>
          Payouts
        </Typography>
      </Header>
      <main id="main">
        <Tabs value={tabHash} onChange={onTabChange}>
          {tabsByRole.map((hash) => (
            <Tab
              key={hash}
              value={hash}
              label={tabs[hash]}
              iconPosition="start"
              style={{
                fontWeight: 500,
                fontSize: '14px',
                fontFamily: 'Visuelt',
                lineHeight: '20px',
                color: 'black',
              }}
            />
          ))}
        </Tabs>
        <div className="mt-5">{renderTab(tabHash)}</div>
      </main>
    </div>
  );
};
